import localstorage from 'redux-localstorage';
import { APPLICATION_NAME } from '../../constants';

export const persistState = localstorage(
  // Whitelist the state keys to store
  ['session', 'signUp', 'siteConfig', 'name', 'moveiq', 'insurance'],
  // Config options
  {
    // The localstorage key to store the state in
    key: `upd_${APPLICATION_NAME}`,
  }
);
